var _style, _ellipse, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCart(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 480 480",
    style: {
      enableBackground: "new 0 0 480 480"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#F5F5F5;}\n\t.st1{fill:url(#SVGID_1_);}\n")), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    className: "st0",
    cx: 240,
    cy: 240,
    rx: 232.1,
    ry: 233.9
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 240,
    y1: 2,
    x2: 240,
    y2: 482,
    gradientTransform: "matrix(1 0 0 -1 0 482)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#12C2E9"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05600001,
    style: {
      stopColor: "#19BFE9"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.137,
    style: {
      stopColor: "#2DB6EA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.235,
    style: {
      stopColor: "#4DA7EA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.344,
    style: {
      stopColor: "#7993EB"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.462,
    style: {
      stopColor: "#B279ED"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.497,
    style: {
      stopColor: "#C471ED"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F64F59"
    }
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M240,0C107.5,0,0,107.5,0,240s107.5,240,240,240s240-107.5,240-240C479.9,107.5,372.5,0.1,240,0z M240,464 C116.3,464,16,363.7,16,240S116.3,16,240,16s224,100.3,224,224C463.9,363.7,363.7,463.9,240,464z M336,176H166.8l-6.9-41.3 c-0.6-3.9-4-6.7-7.9-6.7h-40c-4.4,0-8,3.6-8,8s3.6,8,8,8h33.2l6.9,41.3l16,96c0.6,3.9,4,6.7,7.9,6.7h144c3.9,0,7.2-2.8,7.9-6.7 l16-96c0.4-2.3-0.3-4.7-1.8-6.5S338.4,176,336,176z M313.2,272H182.8l-13.3-80h157.1L313.2,272z M192,304c-13.3,0-24,10.7-24,24 s10.7,24,24,24s24-10.7,24-24S205.3,304,192,304z M192,336c-4.4,0-8-3.6-8-8s3.6-8,8-8s8,3.6,8,8S196.4,336,192,336z M304,304 c-13.3,0-24,10.7-24,24s10.7,24,24,24s24-10.7,24-24S317.3,304,304,304z M304,336c-4.4,0-8-3.6-8-8s3.6-8,8-8s8,3.6,8,8 S308.4,336,304,336z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCart);
export default __webpack_public_path__ + "static/media/cart.72be8d77dead853f57b3ba627d3fe87f.svg";
export { ForwardRef as ReactComponent };